<template>
  <div class="form-container position-absolute top-50 start-50 translate-middle">
    <div class="bb-outer-area">
      <div class="auth-box text-center">
        <img class="mt-4 mb-3" src="/bbLogo32Blue.png" alt="logo" />
        <p class="fw-lighter mt-4 mb-5 bb-app-heading">BATTLEBOARD</p>
        <p class="fs-6 mt-5 mb-5 bb-app-subheading">{{ getPageTitle }}</p>
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <form @submit.prevent="passwordReset">
          <!-- ------------------ -->
          <!--   new password 1   -->
          <!-- ------------------ -->
          <div class="form-group">
            <div class="form-floating password mb-3">
              <input
                v-model="new_password1"
                v-bind:class="{ 'is-invalid': errorFields.includes('new_password1') }"
                name="new_password1"
                class="form-control"
                placeholder="new password"
                :type="fieldTypes.password"
                id="new_password1"
                autocomplete="off"
                required
              />
              <label class="bb-float-label" for="new_password1">New Password</label>
              <!-- ---------------------------- -->
              <!--   show/hide new password 1   -->
              <!-- ---------------------------- -->
              <div class="input-group-addon">
                <i class="bi bi-eye-slash" id="toggleNewPassword1"></i>
              </div>
            </div>
          </div>
          <!-- ------------------ -->
          <!--   new password 2   -->
          <!-- ------------------ -->
          <div class="form-group">
            <div class="form-floating password mb-3">
              <input
                v-model="new_password2"
                v-bind:class="{ 'is-invalid': errorFields.includes('new_password2') }"
                name="new_password2"
                class="form-control"
                placeholder="repeat password"
                :type="fieldTypes.password"
                autocomplete="off"
                id="new_password2"
                required
              />
              <label class="bb-float-label" for="new_password2"> Repeat Password</label>
              <!-- ---------------------------- -->
              <!--   show/hide new password 2   -->
              <!-- ---------------------------- -->
              <div class="input-group-addon">
                <i class="bi bi-eye-slash" id="toggleNewPassword2"></i>
              </div>
            </div>
          </div>
          <!-- ------------ -->
          <!--    errors    -->
          <!-- ------------ -->
          <div v-for="err in errors" :key="err.id" class="bb-error-wrap mt-2">
            {{ err }}
          </div>
          <!-- ------------ -->
          <!--    submit    -->
          <!-- ------------ -->
          <div class="d-grid">
            <button
              type="submit"
              :disabled="!new_password1 || !new_password2"
              class="btn btn-lg btn-primary mt-3"
            >
              Reset Password
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
//----------------------
// scripts
//----------------------
export default {
  name: 'resetPasswordView',
  props: {
    url_id: {
      type: String,
      required: true,
    },
    url_token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      uid: '',
      token: '',
      new_password1: '',
      new_password2: '',
      errors: [],
      errorFields: [],
      fieldTypes: {
        password: 'password',
      },
    }
  },
  //----------------------
  // computed
  //----------------------
  computed: {
    ...mapGetters('auth', {
      getPageTitle: 'getPageTitle',
    }),
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapActions('auth', {
      resetPassword: 'resetPassword',
    }),
    ...mapMutations('auth', {
      setMessage: 'setMessage',
    }),
    //-------------------------
    // reset password method
    //-------------------------
    async passwordReset() {
      this.errors = []
      this.errorFields = []
      const payload = {
        uid: this.uid,
        token: this.token,
        new_password1: this.new_password1,
        new_password2: this.new_password2,
      }
      //----------------------
      // api call
      //----------------------
      await this.resetPassword({ payload })
        //-----------------------------------
        // where successful (force re-logon)
        //-----------------------------------
        .then(() => {
          this.setMessage('Password reset successfully.\nPlease logon with your new credentials.')
          this.$router.push({ name: 'logoutView' })
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          this.errors.push(window.bbErrorMsg(err))
          this.errorFields.push(window.bbErrorKey(err))
        })
    },
  },
  //-------------------------
  // on mount
  //-------------------------
  mounted() {
    this.uid = this.url_id
    this.token = this.url_token
    //-------------------------
    // set bg color
    //-------------------------
    document.body.className = 'bb-bg-partial'
    //---------------------------------
    // toggle password display (setup)
    //---------------------------------
    const toggleNewPassword1 = document.querySelector('#toggleNewPassword1')
    const new_password1 = document.querySelector('#new_password1')
    toggleNewPassword1.addEventListener(
      'click',
      togglePassword.bind(null, toggleNewPassword1, new_password1),
      false
    )

    const toggleNewPassword2 = document.querySelector('#toggleNewPassword2')
    const new_password2 = document.querySelector('#new_password2')
    toggleNewPassword2.addEventListener(
      'click',
      togglePassword.bind(null, toggleNewPassword2, new_password2),
      false
    )
    //------------------------------------
    // toggle password display (function)
    //------------------------------------
    function togglePassword(eye, el) {
      const type = el.getAttribute('type') === 'password' ? 'text' : 'password'
      el.setAttribute('type', type)
      eye.classList.toggle('bi-eye')
    }
  },
  unmounted() {
    document.body.className = 'bb-bg-full'
  },
}
</script>